import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const SOCIAL_LINKS = [
  {
    label: '인스타그램',
    href: 'https://www.instagram.com/whatquiz/',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
      </svg>
    ),
  },
  {
    label: '유튜브',
    href: 'https://www.youtube.com/@팀왓퀴즈',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
      </svg>
    ),
  },
  {
    label: '스레드',
    href: 'https://www.threads.net/@whatquiz',
    icon: (
      <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.589 12c.027 3.086.718 5.496 2.057 7.164 1.43 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.96-.065-1.182.408-2.256 1.33-3.022.88-.733 2.064-1.146 3.524-1.233 1.09-.064 2.108.04 3.04.306-.084-1.265-.592-2.17-1.506-2.676-.614-.34-1.4-.51-2.373-.506-.96.003-1.857.18-2.39.456l-.887-1.81c.743-.366 1.89-.6 3.166-.614h.1c1.394 0 2.568.274 3.49.817 1.338.788 2.108 2.125 2.246 3.88l.014.2c.604.322 1.14.733 1.593 1.236.727.807 1.2 1.82 1.407 3.016.347 2.005-.18 4.225-1.493 6.27C18.695 22.49 15.9 23.974 12.186 24zm.647-7.877c1.166-.064 2.015-.456 2.525-1.169.41-.573.673-1.36.766-2.33-.82-.244-1.73-.36-2.71-.3-1.077.06-1.907.354-2.476.877-.497.457-.742 1.024-.71 1.641.04.723.39 1.34 1.002 1.748.615.408 1.36.589 2.038.589.19 0 .378-.012.565-.035v-.02z" />
      </svg>
    ),
  },
  {
    label: '링크드인',
    href: 'https://www.linkedin.com/in/%EB%9E%99%ED%8B%B0%EC%BB%AC-%ED%94%8C-080832320/',
    icon: (
      <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
  },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-root">
      <div className="footer-inner">
        <div className="footer-grid">
          <section className="footer-brand-section" aria-labelledby="footer-brand">
            <Link id="footer-brand" to="/home" className="footer-brand-link">
              왓퀴즈
            </Link>
            <p className="footer-brand-message">
              반복되는 교사 업무는 AI에게 맡기고, 수업과 학생에게 더 집중하세요.
            </p>
            <p className="footer-company-name">플랙티컬 주식회사 · 대표 강연구</p>
            <p className="footer-business-number">
              사업자등록번호 853-81-03114
              <br />
              통신판매업신고 2024-충남천안-0144
            </p>
          </section>

          <nav aria-label="서비스 바로가기">
            <h2 className="footer-section-title">서비스</h2>
            <div className="footer-links">
              <Link to="/chat" className="footer-link">AI 채팅</Link>
              <Link to="/pricing" className="footer-link">요금 안내</Link>
              <Link to="/help" className="footer-link">고객센터</Link>
              <Link to="/team" className="footer-link">팀 소개</Link>
            </div>
          </nav>

          <nav aria-label="회사와 약관">
            <h2 className="footer-section-title">회사와 약관</h2>
            <div className="footer-links">
              <Link to="/company-info" className="footer-link">회사 정보</Link>
              <Link to="/privacy-policy" className="footer-link">개인정보처리방침</Link>
              <Link to="/terms-of-service" className="footer-link">이용약관</Link>
              <Link to="/refund-policy" className="footer-link">환불정책</Link>
            </div>
          </nav>

          <section aria-labelledby="footer-support">
            <h2 id="footer-support" className="footer-section-title">문의</h2>
            <p className="footer-contact-label">이메일</p>
            <a className="footer-contact-link" href="mailto:angel@plactical.com">
              angel@plactical.com
            </a>
            <p className="footer-contact-label">전화</p>
            <a className="footer-contact-link" href="tel:02-949-9158">
              02-949-9158
            </a>
            <p className="footer-support-hours">
              전화 상담 월~금 09:00~12:00, 13:00~18:00
              <br />
              이메일 상담 매일 09:00~23:00
            </p>
            <div className="footer-social-list" aria-label="왓퀴즈 소셜 미디어">
              {SOCIAL_LINKS.map((social) => (
                <a
                  key={social.label}
                  className="footer-social-link"
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </section>
        </div>

        <div className="footer-bottom">
          <p className="footer-address">
            서울특별시 노원구 공릉로 232, 제1창업보육센터 404호
            (공릉동, 서울과학기술대학교)
          </p>
          <p className="footer-copyright">
            © {currentYear} Plactical Co., Ltd.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
